import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';

const initArchiveCategorySlider = () => {
    const slider = document.querySelector('[data-archive-category-swiper]');
    if (!slider) return;

    let instance = null;

    const build = () => {
        if (instance) return;

        const swiperEl = slider.querySelector('.swiper');
        const pagination = slider.querySelector('.ArchiveCategoriesSlider__pagination');

        instance = new Swiper(swiperEl, {
            modules: [Pagination, Autoplay],
            slidesPerView: '2',
            spaceBetween: 16,
            centeredSlides: false,
            loop: false,
            pagination: {
                el: pagination,
                clickable: true,
            },
            autoplay: {
                delay: 3000,
            },
            breakpoints: {
                640: {
                    spaceBetween: 16,
                },
                1024: {
                    slidesPerView: '5',
                },
            },
        });
    };

    const destroy = () => {
        if (instance) {
            instance.destroy(true, true);
            instance = null;
        }
    };

    build();
    window.addEventListener('resize', () => {
        destroy();
        build();
    });
};

document.addEventListener('DOMContentLoaded', initArchiveCategorySlider);
